export default "__VITE_ASSET___x3P2W0R__"